/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import * as ReactDnD from 'react-dnd';
import PropTypes from 'prop-types';

import * as Constants from '../constants';
import { AttendeeQuestionListItemContainer as AttendeeQuestionListItem } from './attendee_question_list_item.jsx';

class AttendeeQuestionList extends React.Component {
      static propTypes = {
          questions: PropTypes.array,
          defaultQuestions: PropTypes.array,
          onChange: PropTypes.func,
          onDelete: PropTypes.func,
          openedEditors: PropTypes.array,
          onToggleEditor: PropTypes.func,
          onAddAttendeeQuestion: PropTypes.func,
          onDragUpdate: PropTypes.func,
          onDragCancel: PropTypes.func,
          onDragStart: PropTypes.func,
          onDragFinish: PropTypes.func,
          onChoiceAdd: PropTypes.func,
          onChoiceChange: PropTypes.func,
          onChoiceDelete: PropTypes.func,
          onChoiceDragStart: PropTypes.func,
          onChoiceDragUpdate: PropTypes.func,
          onChoiceDragFinish: PropTypes.func,
          onChoiceDragCancel: PropTypes.func
      };

      static defaultProps = {
          questions: [],
          defaultQuestions: [],
          openedEditors: []
      };

      render() {

        let question;
        const empty_message = (this.props.questions.length === 0) && (this.props.defaultQuestions.length === 0) ?
          <tbody>
            <tr>
              <td>
                <a href="#" onClick={this.props.onAddAttendeeQuestion}>Create your first question</a>
              </td>
            </tr>
          </tbody> : undefined;

        const default_question_rows = (() => {
          const result = [];
          for (question of Array.from(this.props.defaultQuestions)) {
            result.push(<AttendeeQuestionListItem question={question}
                                       key={question.id}
                                       editable={false} 
                                       defaultQuestion={true} />);
          }
          return result;
        })();

        const editable_question_rows = (() => {
          const result1 = [];
          for (question of Array.from(this.props.questions)) {
            result1.push(<AttendeeQuestionListItem question={question}
                                       key={question.id}
                                       editable={true}
                                       defaultQuestion={false}
                                       showEditor={this.props.openedEditors.indexOf(question.id) > -1}
                                       onDragStart={this.props.onDragStart}
                                       onDragUpdate={this.props.onDragUpdate}
                                       onDragFinish={this.props.onDragFinish}
                                       onDragCancel={this.props.onDragCancel}
                                       onToggleEditor={this.props.onToggleEditor}
                                       onChange={this.props.onChange}
                                       onDelete={this.props.onDelete}
                                       onChoiceAdd={this.props.onChoiceAdd}
                                       onChoiceChange={this.props.onChoiceChange}
                                       onChoiceDelete={this.props.onChoiceDelete}
                                       onChoiceDragStart={this.props.onChoiceDragStart}
                                       onChoiceDragUpdate={this.props.onChoiceDragUpdate}
                                       onChoiceDragFinish={this.props.onChoiceDragFinish}
                                       onChoiceDragCancel={this.props.onChoiceDragCancel} />);
          }
          return result1;
        })();

        return this.props.connectDropTarget(<table className="form-item-list">
          {empty_message}
          {default_question_rows}
          {editable_question_rows}
        </table>
        );
      }
    }


    const dropSpec = {
      drop(props, monitor, component) {
        if (!monitor.didDrop()) { return { position: 'end' }; }
      },

      hover(props, monitor, component) {
        if (monitor.canDrop() && monitor.isOver({shallow: true})) {
          const item = monitor.getItem();
          return (typeof props.onDragUpdate === 'function' ? props.onDragUpdate(item, 'end') : undefined);
        }
      }
    };

    const dropCollect = (connect, monitor) => ({
      hovered: monitor.isOver(),
      connectDropTarget: connect.dropTarget()
    });

export const AttendeeQuestionListContainer = ReactDnD.DropTarget(Constants.DRAG_TYPE_ATTENDEE_QUESTION, dropSpec, dropCollect)(AttendeeQuestionList);